module.exports = __webpack_public_path__ + "static/media/HTC One M8 Black.a3de9b01.png";